import { useTranslation } from 'react-i18next';
import SideBarItemList from './SideBarItemList';
import SolarClipboardCheckOutline from '../icons/SolarClipboardCheckOutline';
import SolarCalendarLinear from '../icons/SolarCalendarLinear';
import useSettingsParams from 'hooks/useSettingsParams';

export type SideBarTasksProps = {
    variant?: 'manager' | 'team';
};

const SideBarTasks = ({ variant = 'manager' }: SideBarTasksProps) => {
    const { t } = useTranslation();
    const params = useSettingsParams();
    const canViewTasks = !!params.tasksModule;

    if (!canViewTasks) return null;

    const title =
        variant === 'team' ? t('SideBar4Team.titleTasks') : t('SideBarUl.itemTasks');
    const boardLabel =
        variant === 'team'
            ? t('SideBar4Team.titleTasksBoard')
            : t('SideBarUl.itemTasksBoard');
    const calendarLabel =
        variant === 'team'
            ? t('SideBar4Team.titleTasksCalendar')
            : t('SideBarUl.itemTasksCalendar');

    return (
        <SideBarItemList
            title={title}
            icon={<SolarClipboardCheckOutline />}
            iconClass="pc-micon--tasks"
            itemsList={[
                {
                    label: boardLabel,
                    to: '/tasks',
                    icon: <SolarClipboardCheckOutline />,
                },
                {
                    label: calendarLabel,
                    to: '/tasks/calendar',
                    icon: <SolarCalendarLinear />,
                },
            ]}
        />
    );
};

export default SideBarTasks;
